//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import empty from '../empty.vue';
export default {
  name: 'sass_module_plate',
  components: {
    empty: empty
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    module_type: function module_type() {
      var _this$value$default_v;
      return (_this$value$default_v = this.value.default_value[0]) === null || _this$value$default_v === void 0 ? void 0 : _this$value$default_v.module_type;
    },
    Styles: function Styles() {
      var _this$value$config = this.value.config,
        _this$value$config$ti = _this$value$config.title_font_size,
        title_font_size = _this$value$config$ti === void 0 ? 28 : _this$value$config$ti,
        _this$value$config$ti2 = _this$value$config.title_font_color,
        title_font_color = _this$value$config$ti2 === void 0 ? '#000000' : _this$value$config$ti2,
        _this$value$config$ac = _this$value$config.activity_name_font_size,
        activity_name_font_size = _this$value$config$ac === void 0 ? 30 : _this$value$config$ac,
        _this$value$config$ac2 = _this$value$config.activity_name_font_color,
        activity_name_font_color = _this$value$config$ac2 === void 0 ? '#000000' : _this$value$config$ac2;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var titleFontSize = title_font_size / baseSize;
      var activityNameFontSize = activity_name_font_size / baseSize;
      return {
        '--titleFontSize': titleFontSize + 'rem',
        '--titleFontColor': title_font_color,
        '--activityNameFontSize': activityNameFontSize + 'rem',
        '--activityNameFontColor': activity_name_font_color
      };
    }
  }
};